import GreenWhatsappIcon from '@/components/icons/GreenWhatsappIcon';
import { useRouter } from 'next/router';

const WhatsappChat = () => {
  const { locale } = useRouter();
  return (
    <div className='group fixed bottom-8 start-4 z-[888] flex h-12 w-12 items-center justify-center max-[991px]:start-4 max-[991px]:hidden min-[768px]:h-14 min-[768px]:w-14'>
      <span className='absolute start-16 top-1/2 hidden -translate-y-1/2 whitespace-nowrap rounded-md bg-green-500 px-3 py-2 text-sm text-white transition-all duration-500 group-hover:block'>
        {locale === 'en' ? 'Contact with Us' : 'تواصل معنا'}
      </span>
      <a
        href='https://api.whatsapp.com/send/?phone=966920000333&text&type=phone_number&app_absent=0'
        target='_blank'
      >
        <GreenWhatsappIcon className='h-12 w-12 object-contain min-[768px]:h-14 min-[768px]:w-14' />
      </a>
    </div>
  );
};

export default WhatsappChat;
